"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _FeaturesModal = _interopRequireDefault(require("./FeaturesModal"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var _stringUtils = require("../../utils/stringUtils");

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 0 !important;\n  flex: 1;\n  @media (min-width: ", "px) {\n    &:first-child {\n      margin-right: 10px;\n    }\n    &:last-child {\n      margin-left: 10px;\n    }\n  }\n  @media (max-width: ", "px) {\n    &:first-child {\n      margin-bottom: 10px;\n    }\n    &:last-child {\n      margin-top: 10px;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 14px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  padding: 10px 25px;\n  border-top: 1px solid ", ";\n  font-size: 14px;\n  text-align: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 15px;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin-bottom: 27px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 45px 25px 15px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TileFeatureListContainer = _styledComponents.default.div.withConfig({
  displayName: "FeatureTile__TileFeatureListContainer",
  componentId: "igrbmj-0"
})(_templateObject());

var TileHeader = _styledComponents.default.div.withConfig({
  displayName: "FeatureTile__TileHeader",
  componentId: "igrbmj-1"
})(_templateObject2());

var TileViewMoreContainer = _styledComponents.default.div.withConfig({
  displayName: "FeatureTile__TileViewMoreContainer",
  componentId: "igrbmj-2"
})(_templateObject3(), _colors.KOALA);

var FeatureText = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "FeatureTile__FeatureText",
  componentId: "igrbmj-3"
})(_templateObject4());
var FeatureTileContainer = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "FeatureTile__FeatureTileContainer",
  componentId: "igrbmj-4"
})(_templateObject5(), _Breakpoints.FEATURES_SECTION, _Breakpoints.FEATURES_SECTION - 1);

function FeatureTile(_ref) {
  var modalViewClassName = _ref.modalViewClassName,
      header = _ref.header,
      features = _ref.features,
      hubType = _ref.hubType,
      merchandiseId = _ref.merchandiseId;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      featuresModalVisible = _useState2[0],
      setFeaturesModalVisible = _useState2[1];

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(FeatureTileContainer, null, _react.default.createElement(TileFeatureListContainer, null, _react.default.createElement(TileHeader, null, header), Object.keys(features).slice(0, 5).map(function (key) {
    return _react.default.createElement("div", {
      key: key,
      className: "m-bottom-4 flex align-start"
    }, _react.default.createElement(_UIIcon.default, {
      name: "success",
      className: "m-right-3"
    }), _react.default.createElement(_UITooltip.default, {
      placement: "right",
      title: _react.default.createElement(_FormattedMessage.default, {
        message: (0, _getFeatureDescriptionKey.default)(key, hubType)
      })
    }, _react.default.createElement("div", {
      style: {
        display: 'inline-block'
      }
    }, _react.default.createElement(FeatureText, {
      message: "pricing-pages.features." + key + ".name"
    }), features[key].isNew && (0, _stringUtils.hasStringTranslation)('pricingPage.new') && _react.default.createElement(_UIBadge.default, {
      use: "new",
      className: "m-left-1"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.new"
    })))));
  })), _react.default.createElement("div", {
    className: "flex flex-grow-1 align-end"
  }, _react.default.createElement(TileViewMoreContainer, null, _react.default.createElement(_UIButton.default, {
    className: modalViewClassName,
    use: "link",
    onClick: function onClick() {
      setFeaturesModalVisible(true);
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    className: modalViewClassName,
    message: "pricingPage.pages.crm.viewMore"
  }))))), featuresModalVisible && _react.default.createElement(_FeaturesModal.default, {
    merchandiseId: merchandiseId,
    header: header,
    features: features,
    hubType: hubType,
    onModalClose: function onModalClose() {
      setFeaturesModalVisible(false);
    }
  }));
}

var _default = FeatureTile;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/FeatureTile.js
// module id = 580
// module chunks = 5 6